import request from "@/utils/request";
// 查询产品搜索
export function esSearch(query) {
    return request({
        url: '/collect/esSearch',
        method: 'get',
        params: query
    })
}
export function labels(query) {
    return request({
        url: '/collect/labels',
        method: 'get',
        params: query
    })
}
//
export function querySearch(data) {
    return request({
        url: '/collect/query',
        method: 'post',
        data: data
    })
}
export function frontAdd(data) {
    return request({
        url: '/system/signup/front_add',
        method: 'post',
        data: data
    })
}